export class GlobStorage {
    constructor() {
        this.mainStorage = new Map();
    }
    getItem(iKey, storageType) {
        switch (storageType) {
            case 'internal':
            case undefined:
            default:
                return this.mainStorage.get(iKey);
                break;
            case 'session':
                return sessionStorage.getItem(iKey);
                break;
            case 'local':
                return localStorage.getItem(iKey);
                break;
        }
    }
    setItem(iKey, iValue, storageType) {
        switch (storageType) {
            case 'internal':
            case undefined:
            default:
                this.mainStorage.set(iKey, iValue);
                break;
            case 'session':
                sessionStorage.setItem(iKey, String(iValue));
                break;
            case 'local':
                localStorage.setItem(iKey, String(iValue));
                break;
        }
    }
    removeItem(iKey, storageType) {
        switch (storageType) {
            case 'internal':
            case undefined:
            default:
                return this.mainStorage.delete(iKey);
                break;
            case 'session':
                return sessionStorage.removeItem(iKey);
                break;
            case 'local':
                return localStorage.removeItem(iKey);
                break;
        }
    }
    getDebug() { return Boolean(this.getItem('__debug', 'session')); }
    setDebug(debug = true) { this.setItem('__debug', debug, 'session'); }
    getTrace() { return this.getItem('picTrace'); }
    setTrace(trace = true) { this.setItem('picTrace', trace); }
}
//# sourceMappingURL=GlobStorage.js.map